import { render, staticRenderFns } from "./tempMsg.vue?vue&type=template&id=479e7d70&scoped=true&"
import script from "./tempMsg.vue?vue&type=script&lang=js&"
export * from "./tempMsg.vue?vue&type=script&lang=js&"
import style0 from "./tempMsg.vue?vue&type=style&index=0&id=479e7d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e7d70",
  null
  
)

component.options.__file = "tempMsg.vue"
export default component.exports